export default "__VITE_ASSET__B3V2rkVV__"